import { Link } from "@quintype/components";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import MobileHamburgerPage from "./mobile-hamburger-page";
import "./mobile-header.m.css";
import Navbar from "./nav-bar";
import MobileNavItem from "./MobileNavItem";
import CustomHeader from "../../custom-header";

const MobileHeader = ({ signinHandler, onAccountHandler, isHardcodedHeader, showPrimaryHeader = true, showSecondaryHeader = true }) => {
  const getState = useSelector((state) => state);

  const primaryMenus = get(getState, ["qt", "data", "navigationMenu", "primaryMenus"], []);
  const secondaryMenus = get(getState, ["qt", "data", "navigationMenu", "secondaryMenus"], []);
  const isHamburgerMenuOpen = get(getState, ["isHamburgerMenuOpen"], false);
  const currentPath = get(getState, ["qt", "currentPath"], null);

  useEffect(() => {
    if (isHamburgerMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isHamburgerMenuOpen]);


  if (isHardcodedHeader !== "") {
    return (
      <CustomHeader
        isHardcodedHeader={isHardcodedHeader}
        signinHandler={signinHandler}
        onAccountHandler={onAccountHandler}
      />
    );
  }

  if (isHamburgerMenuOpen) {
    return (
      <div styleName="overlay">
        <MobileHamburgerPage
          signinHandler={signinHandler}
          onAccountHandler={onAccountHandler}
          primaryMenus={primaryMenus}
          secondaryMenus={secondaryMenus}
          currentPath={currentPath}
        />
      </div>
    );
  }

  const displayMenus = primaryMenus.slice(0, 5);

  return (
    <header styleName={`header-wrapper ${!showPrimaryHeader ? 'hide-primary' : ''} ${!showSecondaryHeader ? 'hide-secondary' : ''}`}>
      <div styleName="fixed-header">
        <Navbar signinHandler={signinHandler} onAccountHandler={onAccountHandler} />
      </div>

      <div styleName="primary-menus">
        {displayMenus.map((menu, idx) => (
          <MobileNavItem
            key={idx}
            menu={menu}
            currentPath={currentPath}
            allMenus={displayMenus}
            currentIndex={idx}
          />
        ))}
      </div>
    </header>
  );
};

export default MobileHeader;
